import React from 'react';
import { Carousel, Skeleton } from 'antd';
import './CarouselAntd.scss';

const CarouselAntd = ({ images }) => {
  // Si no hay imágenes todavía, mostramos el Skeleton del tamaño del banner
  if (!images || images.length === 0) {
    return (
      <div className="main-carousel-wrapper">
        <div className="skeleton-carousel-container">
          <Skeleton.Button active style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
        </div>
      </div>
    );
  }

  return (
    <div className="main-carousel-wrapper">
      <Carousel 
        autoplay 
       style={{ marginTop: '25px' }}
        speed={800}
        autoplaySpeed={5000}
        easing="ease-in-out"
        dots={{ className: 'custom-dots' }}
        className="blizu-carousel"
      >
        {images.map((imagen, index) => (
          <div key={index} className="slide-item">
             <img 
               src={imagen.url} 
               alt={imagen.nombre} 
               className="carousel-img-responsive" 
               // Optimización: Carga prioritaria para la primera imagen del banner
               fetchpriority={index === 0 ? "high" : "auto"}
             />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselAntd;